var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabMembershipWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.680048 4.29C1.24388 3.79021 2.16069 3.62621 2.85259 3.93546L8.88449 7.72609L9.10315 7.77295L15.4943 0.524361C16.4876 -0.304986 17.7293 -0.117563 18.5399 0.853913L24.6561 7.84323L30.8505 3.93546C32.264 3.37631 33.7134 4.38371 33.7024 5.90184L30.8286 23.8476C30.6178 25.1596 29.5697 26.1139 28.2515 26.2544H5.45309C4.48317 26.1373 3.62259 25.6 3.16028 24.7363C1.83426 18.5279 1.09863 12.1665 0.000639412 5.90184C-0.0149792 5.33645 0.256784 4.66485 0.678486 4.29H0.680048ZM31.1425 6.60936L25.4761 10.1407C24.3703 10.6374 23.5988 10.2797 22.8241 9.46912C20.8468 7.39966 19.0928 4.93505 17.1092 2.87183C17.0452 2.80467 16.9265 2.64068 16.825 2.65786L10.879 9.46912C10.1824 10.3047 9.24684 10.5983 8.22695 10.1407L2.56053 6.60936L4.35198 17.9L29.3152 17.9375L31.1425 6.60936ZM28.9434 20.3881H4.75962C4.95642 21.0019 5.03763 23.3212 5.37812 23.6914C5.44215 23.7617 5.50463 23.821 5.60459 23.8304L27.9595 23.8367C28.2234 23.8617 28.3796 23.6883 28.4561 23.454L28.945 20.3881H28.9434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabMembershipWhite);
export default __webpack_public_path__ + "static/media/tab-membership-white.1810d6e69fe2ea15dde72233fbea1f46.svg";
export { ForwardRef as ReactComponent };